import React from 'react';

function TickIcon({ className = '' }) {
	let fillColor = className.includes('active') ? '#212121' : '#9E9E9E';

	return (
		<svg
			width='17'
			height='17'
			viewBox='0 0 17 17'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={className}
		>
			<path
				d='M8.5 0C3.808 0 0 3.808 0 8.5C0 13.192 3.808 17 8.5 17C13.192 17 17 13.192 17 8.5C17 3.808 13.192 0 8.5 0ZM6.8 12.75L2.55 8.5L3.7485 7.3015L6.8 10.3445L13.2515 3.893L14.45 5.1L6.8 12.75Z'
				fill={fillColor}
			/>
		</svg>
	);
}

export default TickIcon;
